import { Button, ButtonProps } from "@chakra-ui/react";

interface NewBadgeProps extends Omit<ButtonProps, "children"> {}

export function NewBadge({ ...rest }: NewBadgeProps) {
  return (
    <Button
      variant="primary"
      colorScheme="blaze"
      size="xs"
      fontSize="10px"
      fontWeight="bold"
      px={2}
      py={1}
      height="20px"
      borderRadius="6px"
      clipPath="inset(0 0 0 0 round 6px)"
      pointerEvents="none"
      boxShadow="0px 8px 24px 0px rgba(255, 90, 44, 0.30)"
      background={[
        "radial-gradient(50% 76.22% at 50% 100%, color-mix(in srgb, white 25%, var(--chakra-colors-blaze-600)) 0%, var(--chakra-colors-blaze-600) 100%) padding-box",
        "linear-gradient(to bottom, color-mix(in srgb, white 20%, var(--chakra-colors-blaze-600)), color-mix(in srgb, white 0%, var(--chakra-colors-blaze-600)) 80%) border-box",
      ].join(",")}
      backgroundSize="100% 100%"
      border="1px solid transparent"
      {...rest}
    >
      NEW
    </Button>
  );
}
